module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "hexagram",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "hexagram ornament",
      "src": "image/Unicursal_Hexagram.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "_tx_ded"
  }, [_vm._v("Do what thou wilt shall be the whole of the Law.")]), _vm._v(" "), _c('p', {
    staticClass: "_tx_ded"
  }, [_vm._v("—Aleister Crowley")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5747bfe8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epi.vue
// module id = 78
// module chunks = 0